
export const maskIban = iban => {
    let maskedIban = '';
    for (let i = 0; i < iban.length; i += 1) {
        i < iban.length - 4 ? maskedIban += '*' : maskedIban += iban[i];
    }
    return maskedIban;
};
